enum AITweakActionTypes {
    GET_PROJECT_AI_TWEAK = "aiTweak/getProjectAITweak",
    GET_PROJECT_AI_TWEAK_SUCCESS = "aiTweak/getProjectAITweakSuccess",
    CREATE_AI_TWEAK_INTERACTION = "aiTweak/createAITweakInteraction",
    UPDATE_AI_TWEAK_INTERACTION = "aiTweak/updateAITweakInteraction",
    SAVE_AI_TWEAK_CHAT_HISTORY = "aiTweak/saveAITweakChatHistory",
    SET_AI_TWEAK_CHAT_RATING = "aiTweak/setAITweakChatRating",
    STOP_AI_TWEAK = "aiTweak/stopAITweak"
}

export default AITweakActionTypes;
